import React, {useContext, useMemo, useRef} from "react";
import {inject, observer} from "mobx-react";
import { RootStore } from 'stores';
import _ from "lodash";
import {
    BaseButton,
    DataTablePresenter,
    isTabletPortraitDown,
    ITableColumn,
    ProviderIntegrationApi,
    Spinner,
    ToastContext
} from "@enter/core";
import * as S from "./shared.styles";
import {Icon} from "@mdi/react";
import {mdiArrowLeft, mdiPlus, mdiDelete} from "@mdi/js";
import { DialogContext } from 'services';
import { SecretToggle, ConfirmDialog } from './components';
import {ApiKeyModal} from "./api-key-modal/api-key-modal";
import styled from "@emotion/styled/macro";

const ActionsContainer = styled.div`
  
`;

export const Api: React.FunctionComponent<{}> = inject('rootStore')(
    observer(
        (props: {}): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const toastContext = useContext(ToastContext);
            const dialogContext = useContext(DialogContext);

            const { settingsStore } = rootStore;

            const columns: ITableColumn<ProviderIntegrationApi>[] = useMemo(
                () => [
                    {
                        id: 'Name',
                        Header: () => <S.TableHeader>Name</S.TableHeader>,
                        Cell: ({ row }): React.ReactElement => <S.TableCell>{row.original.name}</S.TableCell>
                    },
                    {
                        id: 'Client Id',
                        Header: () => <S.TableHeader>Client Id</S.TableHeader>,
                        Cell: ({ row }): React.ReactElement => <S.TableCell>{row.original.clientId}</S.TableCell>
                    },
                    {
                        id: 'Client Secret',
                        Header: () => <S.TableHeader>Secret</S.TableHeader>,
                        Cell: ({ row }): React.ReactElement => {
                            return <SecretToggle>{row.original.clientSecret}</SecretToggle>
                        }
                    },
                    {
                        id: 'Delete',
                        width: '50px',
                        Cell: ({ row }): React.ReactElement => {

                            const handleDelete = async () => {
                                if(row.original.id) {
                                    console.log("Deleting " + row.original.id);
                                    await settingsStore.deleteAPIKey(row.original.id);
                                }
                                dialogContext.hideDialog?.();
                            };

                            const handleModalOpen = () => {
                                dialogContext.showDialog?.({
                                    props: dialogProps,
                                    Component: <ConfirmDialog onSubmit={handleDelete} onCancel={handleCancel} />,
                                });
                            }

                            const handleCancel = (): void => {
                                console.log("Cancel delete API");
                                dialogContext.hideDialog?.();
                            };

                            const dialogProps = {
                                onClose: handleCancel,
                                disableBackdropClick: true,
                                disableEscapeKeyDown: true,
                                renderTitle: 'Are you sure you want to delete ' + row.original.name + '?',
                            };

                            return <BaseButton variant="fab-light" size="large" onClick={handleModalOpen}>
                                    <Icon path={mdiDelete} size={1} />
                                </BaseButton>;
                        }
                    }
                ],
                [],
            );

            const handleAddKeyClose = (): void => {
                console.log("Closed API Key Modal Dialog");
                dialogContext.hideDialog();
            };

            const handleOnSave = async (name: string): Promise<void> => {
                console.log("Saving " + name);
                await settingsStore.createAPIKey(name);
                toastContext.notify && toastContext.notify('API Key Created');
                dialogContext.hideDialog();
            }

            const onClickAddKey = (): void => {
                dialogContext.showDialog({
                    props: {
                        onClose: handleAddKeyClose,
                        disableBackdropClick: true,
                        disableEscapeKeyDown: true,
                        renderTitle: 'Create API Key',
                    },
                    Component: (
                        <ApiKeyModal
                            onClose={handleAddKeyClose}
                            onSubmit={handleOnSave}
                        />
                    ),
                });
            };

            const buildDataPresenter = (): DataTablePresenter<ProviderIntegrationApi> => {
                return new DataTablePresenter({
                    name: 'integrationApis',
                    data: settingsStore.integrationApis ? settingsStore.integrationApis : [],
                    columns,
                    filterSchemas: [],
                })
            }

            return (!settingsStore.integrationApis) ? <Spinner/> : <S.SubCategoryCol>
                <S.SubCategoryItem key="members">
                    <S.SubCategoryItemRow>
                        <S.SubCategoryH1>
                            {isTabletPortraitDown() && (
                                <S.ReturnLink to="/settings">
                                    {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                                </S.ReturnLink>
                            )}
                            API Keys
                        </S.SubCategoryH1>
                        <S.SubCategoryAddButton variant="primary" onClick={onClickAddKey}>
                            <S.SubCategoryPlus path={mdiPlus} size={1} /> Add new API Key
                        </S.SubCategoryAddButton>
                    </S.SubCategoryItemRow>
                    <S.Table presenter={buildDataPresenter()} hideFiltering={true} hidePagination={true} hideSettings={true} />
                </S.SubCategoryItem>
            </S.SubCategoryCol>;
        },
    ),
);